export default __webpack_public_path__ + "static/media/reports.615dc4f0.svg";